import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, Observable, shareReplay } from 'rxjs';

/** The app's mobile breakpoint — below 1024px the layout switches to its mobile form. */
export const HANDSET_MAX_WIDTH = '(max-width: 1023.98px)';

/**
 * Single source of truth for the responsive breakpoint. One shared observer feeds
 * both an observable (`isHandset$`) and a signal (`isHandset`) so components pick
 * whichever fits their template, instead of each wiring its own BreakpointObserver.
 */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly breakpointObserver = inject(BreakpointObserver);

  /** Emits true below 1024px. */
  readonly isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(HANDSET_MAX_WIDTH)
    .pipe(
      map((result) => result.matches),
      shareReplay(1),
    );

  /** Signal form of {@link isHandset$} (false until the first match resolves). */
  readonly isHandset: Signal<boolean> = toSignal(this.isHandset$, { initialValue: false });
}
